import { Dialog } from "arkh";
import React from "react";

import {
  TeamSelectList,
  TeamSelectListWholeStoreOption,
} from "./TeamSelectList";

import { TeamSelectList_Team$key } from "./__generated__/TeamSelectList_Team.graphql";
import { FormattedMessage } from "react-intl";

export function TeamSelectPopover(props: {
  teamIds: string[];
  visible: boolean;
  onClose: () => void;
  onSelectAll: () => void;
  onItemPress(itemId: string, selected: boolean): void;
  teams: TeamSelectList_Team$key;
}) {
  return (
    <Dialog
      onClose={props.onClose}
      minHeight={400}
      visible={props.visible}
      title={
        <FormattedMessage
          description="TeamSelectPopover title"
          defaultMessage="Teams"
        />
      }
    >
      <TeamSelectList
        insets={{
          bottom: 0,
        }}
        contentBox={{
          space: "medium",
        }}
        teams={props.teams}
        selected={props.teamIds}
        ListHeaderComponent={
          <TeamSelectListWholeStoreOption
            onSelect={props.onSelectAll}
            selected={props.teamIds.length === 0}
          />
        }
        onItemPress={props.onItemPress}
      />
    </Dialog>
  );
}
